<template>
  <div class="global-navi-un-login">
    <p class="global-navi-login-appeal">ログインして便利に使おう！</p>
    <a class="global-navi-btn-login" :href="loginUrl">ログイン・メンバー登録</a>
  </div>
</template>

<script>
export default {
  name : 'side-menu-login',
  props: {
    loginUrl: {
      type   : String,
      default: '',
    },
  },
};
</script>
